// Canonical image identity, derived purely from the complex-plane bounds.
//
// Two fractal images are "the same image" iff they cover the same coordinate
// region, so their identity is the region itself — not a render timestamp or a
// list position. This is the uniqueness key Phase 2 enforces on server-side
// (once a region is claimed/bought, no one else can claim it), so it is kept
// lossless and deterministic: the same bounds always produce the same id, and
// different bounds never collide. Number -> string here uses JS's canonical
// shortest round-trippable form, so the frontend key and a future server-side
// claim check agree on what counts as identical.
const coordId = ({ realMin, realMax, imaginaryMin, imaginaryMax }) =>
    `${realMin}:${realMax}:${imaginaryMin}:${imaginaryMax}`;

export default coordId;
